<template>
  <div class="modal fade modal-addCash modal-wechatpay" tabindex="-1" role="dialog" id="Modal_wechatpay">

    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div>
          <button type="button" class="close" @click="cancalPay"><i class="icon-close"></i></button>
        </div>
        <div class="modal-body">
          <div class="white-box addCash-wrapper">
            <div class="form-group mb30">
              <label for="CashInput">支付金额</label>
              <div class="input-group">
                <i class="icon-cash"></i>
                <span class="price-cash">{{ order.price/100 }}</span>
              </div>
            </div>

            <div  style="text-align: center">
              <!--<div id="qrcode" style="width: 260px; height: 100%;"></div>-->
              <canvas id="canvas" style="width: 260px; height: 100%;"></canvas>
            </div>
            <div style="text-align: center">
              <img style="width: 260px; height: 100%;" alt="加载中" src="../assets/img/wechatScan.png">
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {showModal, hideModal, ajax} from '@/api/global'
  import QRCode from 'qrcode'

  export default {
    name: "ModaWechatlPay",
    props: ['order'],
    data: function () {
      return {
        price : 0,
        qrcodeurl: '',

        corps : {},
        user : {},
        charge : null,
        isShow: false,
        checkNumber: 0,
        interval: 0
      }
    },
    methods: {
      qrcode () {
        console.info('qrcodeurl : '+this.order.qrcodeurl);
        //生成的二维码内容，可以添加变量
        var canvas = document.getElementById('canvas');
        QRCode.toCanvas(canvas, this.order.qrcodeurl, function (error) {
          if (error) console.error(error)
          console.log('success!');
        });
        this.isShow = true;
        if (this.interval==0) this.interval = setInterval(()=>{this.checkPayStatus()},2000);
        console.info('interval start : '+this.interval);
      },
      checkPayStatus () {
        var self = this;
        if (self.isShow) {
          self.checkNumber ++
          console.info('checkPayStatus ----' + self.checkNumber);
          ajax({
            url : 'api/app-service/pay/isRrecharged',
            type : 'get',
            async : false,
            data : {
              walletRecordId: self.order.walletRecordId
            },
            success : function (res) {
              console.info(res.data);
              var isPaySuccse = res.data;
              if (isPaySuccse) {

                self.paySuccess();
              } else {
                // console.info(level);
                // if (level<3) {
                //   self.checkPayStatus(level + 1)
                // } else {
                //   self.payFail.call(self);
                // }
                return;

              }
            },
            error : function (e) {
              console.info(e);
              alert('检查支付结果失败, 请重试!');
              // this.$vDialog.alert('检查支付结果失败, 请重试!', null, {messageType: 'error'});
            }
          });
        } else {
          console.info('11111111111111111111111');
          return
        }


      },
      cancalPay() {
        clearInterval(this.interval);
        this.interval = 0;
        console.info('interval end : '+this.interval);
        self.checkNumber = 0;
        self.isShow = false;
        this.$emit('payResult',false);
        hideModal('wechatpay');
      },
      payFail : function (err) {
        clearInterval(this.interval);
        this.interval = 0;
        this.$emit('payResult',false);
        // alert(err ? err.message : '支付失败, 请重试!');
      },
      paySuccess : function () {
        clearInterval(this.interval);
        this.interval = 0;
        self.checkNumber = 0;
        self.isShow = false;
        this.$emit('payResult',true);

        hideModal('wechatpay');
        // alert('支付成功, 请前往附近印箱打印!');
        // this.$router.push('/print-map');
      },

    },
    created: function () {
      console.info('modal-pay-init');
    },
    mounted () {
      // this.qrcode();


    },
    watch: {
      order: {
        handler(newValue, oldValue) {
          console.log(JSON.stringify(oldValue)+'================================'+JSON.stringify(this.order));
          if (newValue.orderId!='') this.qrcode();
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .icon-cash{
    top: 0px;
  }
  .price-cash{
    /*display: block;*/
    font-size: 38px;
    margin-left: 30px;
  }
  #canvas{
    width: 80%!important;
    height: auto!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ModalWechatPay.vue